// Helpers to preserve current URL query string when navigating

export const appendCurrentQuery = (location, targetPath) => {
  if (!location || !location.search) return targetPath;
  const hasQuery = targetPath.includes('?');
  const currentQuery = location.search.startsWith('?') ? location.search.slice(1) : location.search;
  return `${targetPath}${hasQuery ? '&' : '?'}${currentQuery}`;
};

export const navigateWithCurrentQuery = (navigate, location, targetPath, options) => {
  const url = appendCurrentQuery(location, targetPath);
  navigate(url, options);
};


